// Общий meta экранов карт: вкладка «Карта» в таббаре (tabbar.vue), без нижнего меню.
// Родитель без компонента и имени: дети рендерятся в корневом router-view, пути у них абсолютные
export const cardRoutes = [
  {
    path: "/",
    meta: { parent: "Card", menu: false },
    children: [
      {
        path: "/card",
        name: "Card",
        component: () => import("@/views/Card/index.vue"),
        meta: { topLevel: true, menu: true, showDemoVersion: true },
      },
      {
        path: "/card-empty-state",
        name: "CardEmptyState",
        component: () => import("@/views/Card/EmptyState.vue"),
        meta: {
          topLevel: true,
          menu: true,
          showDemoVersion: true,
          noPagePadding: true,
        },
      },
      // Каталог тарифов из CardsIndex («Открыть карту»): тот же экран, что CardEmptyState, но с «Назад»
      {
        path: "/cards/catalog",
        name: "CardCatalog",
        component: () => import("@/views/Card/EmptyState.vue"),
        meta: {
          menu: true,
          showDemoVersion: true,
          noPagePadding: true,
        },
      },
      {
        path: "/card-about",
        name: "CardAbout",
        component: () => import("@/views/Card/About.vue"),
        meta: { showDemoVersion: true },
      },
      {
        path: "/cards",
        name: "CardsIndex",
        component: () => import("@/views/Card/CardsIndex.vue"),
        meta: { topLevel: true, menu: true },
      },
      {
        path: "/cards/history",
        name: "CardsHistory",
        component: () => import("@/views/Card/CardsHistory.vue"),
      },
      {
        path: "/card/:id",
        name: "CardView",
        component: () => import("@/views/Card/Issued/index.vue"),
        meta: { menu: true },
      },
      {
        path: "/card/:id/topup",
        name: "TopupCard",
        component: () => import("@/views/Card/Issued/TopupCard.vue"),
      },
      {
        path: "/card/:id/topup/status",
        name: "TopupCardStatus",
        component: () => import("@/views/Card/Issued/Topup/TopUpStatus.vue"),
        meta: { transparentHeader: true },
      },
      {
        path: "/card/:id/reissue/status",
        name: "CardReissueStatus",
        component: () =>
          import("@/views/Card/Issued/Reissue/ReissueStatus.vue"),
        meta: { topLevel: true },
      },
      {
        path: "/card/:id/reissue",
        name: "CardReissue",
        component: () => import("@/views/Card/Issued/Reissue/CardReissue.vue"),
      },
      {
        path: "/card/:id/close",
        name: "CardClose",
        component: () => import("@/views/Card/Issued/Close/CardClose.vue"),
      },
      {
        path: "/card/:id/close/reasons",
        name: "CardCloseReasons",
        component: () =>
          import("@/views/Card/Issued/Close/CardCloseReasons.vue"),
      },
      {
        path: "/card/:id/close/status",
        name: "CardCloseStatus",
        component: () =>
          import("@/views/Card/Issued/Close/CardCloseStatus.vue"),
        meta: { topLevel: true },
      },
      {
        path: "/create-card/",
        name: "CreateCard",
        component: () => import("@/views/Card/NewCard/CreateCard.vue"),
      },
      {
        path: "/create-card/confirm",
        name: "CreateCardConfirm",
        component: () => import("@/views/Card/NewCard/CreateCardConfirm.vue"),
      },
      {
        path: "/create-card/email",
        name: "CreateCardEmail",
        component: () => import("@/views/Card/NewCard/CreateCardEmail.vue"),
      },
      {
        path: "/create-card/phone",
        name: "CreateCardPhone",
        component: () => import("@/views/Card/NewCard/CreateCardPhone.vue"),
      },
      {
        path: "/card/:id/email",
        name: "CardChangeEmail",
        component: () => import("@/views/Card/NewCard/CreateCardEmail.vue"),
      },
      {
        path: "/card-kyc/waiting",
        name: "WaitingKyc",
        component: () => import("@/views/Card/KYC/WaitingKyc.vue"),
        meta: { showsKycStatus: true },
      },
      {
        path: "/card-kyc/cancel",
        name: "ConfirmCancelOrder",
        component: () => import("@/views/Card/KYC/ConfirmCancelOrder.vue"),
      },
      {
        path: "/pending-card",
        name: "PendingCard",
        component: () => import("@/views/Card/KYC/PendingCard.vue"),
        meta: { topLevel: true },
      },
      {
        path: "/card-issue-failed",
        name: "CardIssueFailed",
        component: () => import("@/views/Card/KYC/CardIssueFailed.vue"),
        meta: { topLevel: true },
      },
    ],
  },
];
